import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import Typography from 'Components/UI/Typography';
import Button from 'Components/UI/Button';
import LoadingIndicator from 'Components/UI/LoadingIndicator';

const styles = theme => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
    marginTop: theme.spacing(2),
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
  },
  table: {
    overflow: 'scroll',
    flexBasis: '19em',
    marginLeft: theme.spacing(2),
  },
  row: {
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'center',
    marginTop: theme.spacing(1),
  },
  column: {
    flex: 1,
    textAlign: 'left',
  },
  status: {
    borderRadius: theme.radius.lg,
    backgroundColor: theme.palette.facet.accentGreen2,
    minWidth: '100px',
    textAlign: 'center',
  },
  statusText: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  statusDate: {
    padding: theme.spacing(1),
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.facet.darkGray,
  },
});

const View = ({
  classes, rows, loading, onClickInvestigation, amplitudeRootNodeProps,
}) => {
  return (
    <Box className={classes.root} debugColor="chartreuse" {...amplitudeRootNodeProps}>
      <Typography
        variant="h3"
        color="primary"
        className={classes.title}
      >
        Investigations
      </Typography>
      <div className={classes.table}>
        {loading ? (<LoadingIndicator />) : rows.map(row => (
          <div className={classes.row}>
            <div className={classes.column}>
              <Button
                className={classes.status}
                style={{
                  backgroundColor: row.statusColors.backgroundColor,
                }}
                onClick={() => onClickInvestigation(row.resource)}
              >
                <Typography
                  className={classes.statusText}
                  variant="h6"
                  color={row.statusColors.textColor}
                >
                  {row.status}
                </Typography>
              </Button>
            </div>
            <div className={classes.column} style={{ flex: 2.5 }}>
              <Typography
                className={classes.statusDate}
                variant="h6"
              >
                {row.date}
              </Typography>
            </div>
          </div>
        ))}
      </div>
    </Box>
  );
};

View.propTypes = {
  classes: PropTypes.object.isRequired,
  rows: PropTypes.array,
  loading: PropTypes.bool,
  onClickInvestigation: PropTypes.func.isRequired,
  amplitudeRootNodeProps: PropTypes.object.isRequired,
};
View.defaultProps = {
  rows: [],
  loading: false,
};

export default withStyles(styles)(View);
